module.exports = __webpack_public_path__ + "img/academyBg4.4e720e91.4e720e91.jpg";